import { AuthTokenDTO, LoginRequestDTO } from 'infrastructure/dtos/login';
import { BaseApi } from '../base/BaseApi';
import { type IUserApi } from './IUserApi';
import { ApiRoutes } from '../routes';
import { UserDTO } from 'infrastructure/dtos/user';
import { AxiosClient } from 'infrastructure/axiosClient/AxiosClient';
import { type ITokenStorage } from 'infrastructure/storage';

export class UserApi extends BaseApi implements IUserApi {
  private readonly tokenStorage: ITokenStorage;

  constructor(axiosClient: AxiosClient, tokenStorage: ITokenStorage) {
    super(axiosClient);
    this.tokenStorage = tokenStorage;
    this.restoreAuthToken();
  }

  private restoreAuthToken(): void {
    const token = this.tokenStorage.getToken();
    if (token) {
      this.axiosClient.setAuthToken(token);
    }
  }

  public async login(dto: LoginRequestDTO): Promise<void> {
    const tokenDTO: AuthTokenDTO = await this.callApi(ApiRoutes.User.Login, dto);

    this.tokenStorage.saveToken(tokenDTO.access_token);
    this.axiosClient.setAuthToken(tokenDTO.access_token);
  }

  public async logout(): Promise<void> {
    await this.callApi(ApiRoutes.User.Logout);

    this.tokenStorage.removeToken();
    this.axiosClient.unsetAuthToken();
  }

  public async authenticate(): Promise<UserDTO> {
    return await this.callApi(ApiRoutes.User.Authenticate);
  }

  public async updateFCMToken(dto: { fcm_token: string }): Promise<void> {
    await this.callApi(ApiRoutes.User.UpdateFCMToken, dto);
  }

  public async deleteAccount(): Promise<void> {
    await this.callApi(ApiRoutes.User.DeleteAccount);

    this.tokenStorage.removeToken();
    this.axiosClient.unsetAuthToken();
  }

  public isAuthenticated(): boolean {
    return this.tokenStorage.hasToken();
  }
}
